import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "star_white_empty",
  "use": "star_white_empty-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"star_white_empty\"><path d=\"M.497 5.867c.004.012.023.015.083.005l4.789-.73.113-.24L7.5.621l2.131 4.52.264.04 4.517.69c.121.02.088-.009.088-.06 0-.01-.023.036-.082.104l-3.459 3.527.041.25.773 4.713.005.037L7.5 12.085l-.241.133-4.035 2.224v-.023l.817-4.975-.177-.181L.596 5.92c-.045-.047-.07-.08-.084-.097zM11.906 14.5h.002a.04.04 0 0 1-.008 0zm-8.678.078a.146.146 0 0 1-.001-.002z\" stroke=\"#FFF\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol